/**
 * CatalogCardModal — прежнее имя каркаса окна карточки каталога.
 *
 * Каркас переехал в `components/entity-view/EntityModalShell` и стал общим для
 * всех окон сущностей. Это имя остаётся на время переезда окон: API то же,
 * новые необязательные свойства каркаса доступны и здесь.
 */

import { EntityModalShell } from '../../../components/entity-view/EntityModalShell'
import type { EntityModalShellProps } from '../../../components/entity-view/EntityModalShell'

export type CatalogCardModalProps = EntityModalShellProps

export const CatalogCardModal = EntityModalShell

export default CatalogCardModal
